<template>
<div class="content content-full">
    <div class="page-inner">
      <div class="page-header">
        <h4 class="page-title">{{ campaign.name }} </h4>
        <ul class="breadcrumbs">
          <li class="nav-home">
            <router-link to="/dashboard">
              <i class="flaticon-home"></i>
            </router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <router-link to="/presave-campaigns">{{ $t('presave_campaigns') }}</router-link>
          </li>
        </ul>
      </div>

      <div class="card">
        <div class="card-body pos-relative">
          <div class="d-block" style="height: 300px;">
            <canvas ref="campaignsChart"></canvas>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <div class="card">
          <div class="card-body p-0">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>{{ $t('subscriber') }}</th>
                  <th>{{ $t('campaign') }}</th>
                  <th>{{ $t('followers') }}</th>
                  <th>{{ $t('country') }}</th>
                  <th class="hide-mobile">{{ $t('subscribed') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="subscriber in subscribers" v-bind:key="subscriber._id">
                  <td>
                    <a :href="subscriber.spotify_url" target="_blank" class="d-none d-md-inline">
                      <img :src="subscriber.image" width="32" class="rounded mr-2" onerror="this.src = '//indiefy.net/img/img-placeholder.jpg'">
                    </a>
                    <a :href="subscriber.spotify_url" target="_blank">
                      {{ subscriber.name }}
                    </a>
                  </td>
                  <td>
                    {{ subscriber.campaign }}
                  </td>
                  <td>
                    {{ subscriber.followers }}
                  </td>
                  <td>
                    <img :src="`/static/img/countries/${subscriber.country || 'default'}.png`" width="16" class="mr-1" :alt="subscriber.country" :title="subscriber.country">
                  </td>
                  <td class="hide-mobile">
                    {{ subscriber.date }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Presave from '../services/presave'

export default {
  name: 'PresaveCampaign',
  data: function () {
    return {
      subscribers: [],
      campaign: {},
      user: {}
    }
  },
  methods: {
    renderChart: function () {
      let ctx = this.$refs.campaignsChart.getContext('2d')
      let days = []
      let data = []
      let labels = []
      let campaigns = []
      let colors = [
        { bg: '#D9E7ED', border: '#509BF5' },
        { bg: '#FFB1C1', border: '#FF6383' },
        { bg: '#FFE6AC', border: '#FFD575' }
      ]

      _.each(this.campaign.subscribers, user => {
        user.date = moment(user.createdAt).format('MMM, DD, YYYY')
        // let newData = _.clone(data)

        // if (_.indexOf(days, user.date) !== -1) {
        //   newData[_.indexOf(days, user.date)]++
        // }

        this.subscribers.push({
          campaign: this.campaign.name,
          name: user.subscriber.display_name,
          spotify_url: user.subscriber.external_urls.spotify,
          followers: user.subscriber.followers.total,
          image: user.subscriber.images.length ? user.subscriber.images[0].url : 'https://d2zkax1qtp294k.cloudfront.net/static/img-placeholder.jpg',
          country: user.country,
          date: user.date
        })
      })

      for (let i = 0; i <= 30; i++) {
        let label = ''

        if (i % 10 === 0 || i === 30) {
          label = moment().subtract(i, 'days').format('MMM, DD')
        }

        labels.push(label)
        days.push(moment().subtract(i, 'days').format('MMM, DD, YYYY'))
        data.push(_.filter(this.subscribers, sub => sub.date === moment().subtract(i, 'days').format('MMM, DD, YYYY')).length)
      }

      days = days.reverse()
      labels = labels.reverse()
      data = data.reverse()

      campaigns.push({
        label: this.campaign.name,
        backgroundColor: colors[0].bg,
        borderColor: colors[0].border,
        data: data
      })

      // eslint-disable-next-line
      new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: campaigns
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                stepSize: 1
              }
            }]
          }
        }
      })
    }
  },
  created: function () {
    this.user = this.$user
  },
  mounted: function () {
    Presave.getCampaignChartData(this.$route.params.id).then(response => {
      this.campaign = response.data
      this.renderChart()
    })
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/PresaveCampaign.vue